import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function StatusConfig({ obj, onChange }) {
  const { t } = useTranslation('common');
  const [isStatusEditTrue, setIsStatusEditTrue] = useState(false);
  return (
    <div className="status-config-container">
      <div className="input-group form-floating-label fixed-label">
        <button type="button" className="btn btn-default w-100 m-0 mb-2" value={isStatusEditTrue} onClick={() => setIsStatusEditTrue(!isStatusEditTrue)}>
          <span className="icon-edit mr-2" />
          {t('CUSTOM_MODULE.EDIT_COLOR')}
        </button>
        {obj?.statusColours?.map((stat, keyIn) => {
          return (
            <button
              type="submit"
              key={stat}
              className="status-color-option"
              onClick={() => onChange(true, 'setDefault', keyIn)}
              style={
                stat?.setDefault
                  ? {
                      border: '2px solid #8d8dff',
                    }
                  : {}
              }
            >
              <div className="color-content">
                <input
                  type="color"
                  className="form-control"
                  value={stat?.colourHexCode}
                  onChange={(e) => onChange(e.target.value, 'colourHexCode', keyIn)}
                  disabled={!isStatusEditTrue}
                />
              </div>
              <input
                type="text"
                className="text-content f-14"
                value={stat?.colourName}
                placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.STATUS_CONFIG.ADD_COLOR_NAME')}
                onChange={(e) => onChange(e.target.value, 'colourName', keyIn)}
                readOnly={!isStatusEditTrue}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default StatusConfig;
